import type { Account } from "@ca/shared";
import { Theory } from "./revision-theory.tsx";
import { Errors } from "./revision-errors.tsx";
import { Vocab } from "./revision-vocab.tsx";
import { Dictation } from "./revision-dictation.tsx";
export function RevisionPage({
  account,
  path,
  notify,
}: {
  account: Account;
  path: string;
  notify: (text: string) => void;
}) {
  const props = { uid: account.id, notify, theme: account.profile.settings.skin };
  return path === "/grammar" ? (
    <Theory {...props} />
  ) : path === "/vocab" ? (
    <Vocab {...props} />
  ) : path === "/errors" ? (
    <Errors {...props} />
  ) : (
    <Dictation {...props} />
  );
}
